module.exports = __webpack_public_path__ + "static/media/internet.c3c817e9.svg";